export default __webpack_public_path__ + "static/us-enterprise-cut-costs-1eaf5bd223f8dae6c53b2c9e0944a14a.gif";